import {EntityKeyService} from "@pma-entity/services/entity-key.service";
import {EntityDataLayoutService} from "@layout/layouts/entity-data/entity-data-layout.service";
import { Observable, takeUntil } from "rxjs";
import { Directive } from "@angular/core";
import {EntityKey} from "@pma-entity/pma-entity-types";
import { OnDestroySubject } from "@common/components/on-destroy-subject";

@Directive()
export abstract class ListPageComponentBase
  extends OnDestroySubject {

  protected entityKey$: Observable<EntityKey>;

  protected constructor(
    protected readonly entityKeyService: EntityKeyService,
    protected readonly entityDataLayoutService: EntityDataLayoutService) {
    super();
  }

  ngOnInit(viewName: string): void {
    this.entityDataLayoutService.updateViewName(viewName);
    this.entityKey$ = this.entityKeyService.getEntityKey().pipe(
      takeUntil(this.destroy$),
    );
    this.entityKey$.subscribe(x => this.entityDataLayoutService.updateEntityKey(x));
  }
}
